export enum Feature {
    CanSeeSensitiveData = 'CanSeeSensitiveData',
    ViewDocumentList = 'ViewDocumentList',
    OpenDocument = 'OpenDocument',
    ViewClearReport = 'ViewClearReport',
    Refresh = 'Refresh',
    ViewApplicant = 'ViewApplicant',
    RedirectAlloy = 'RedirectAlloy',
    RedirectSalesforce = 'RedirectSalesforce',
    DebugMenu = 'DebugMenu',
    AddNotes = 'AddNotes',
    AddDocuments = 'AddDocuments',
    DecisionMakingLoadpay = 'DecisionMakingLoadpay',
    NeedsMoreInfo = 'NeedsMoreInfo',
    Assign = 'Assign',
    DecisionMakingFactoring = 'DecisionMakingFactoring',
    ProtectedConditions = 'ProtectedConditions',
    Edit = 'Edit',
    ManageTemplates = 'ManageTemplates',
    EditTemplates = 'EditTemplates'
}

export const PERMISSION_DENIED_TITLE = "You don't have permission to perform this action";

export const ELEVATED_PERMISSIONS_REQUIRED_TEXT = 'Elevated permissions are required to view information.';
